import React from 'react';

const SearchIcon: React.FC<{ size?: string; color?: string }> = ({
  size = "22px",
  color = "#9AA9B3",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2498 9.5C16.2498 10.3864 16.0753 11.2642 15.736 12.0831C15.3968 12.9021 14.8996 13.6462 14.2728 14.273C13.646 14.8998 12.9019 15.397 12.083 15.7362C11.264 16.0754 10.3863 16.25 9.49984 16.25C8.61342 16.25 7.73568 16.0754 6.91673 15.7362C6.09778 15.397 5.35367 14.8998 4.72687 14.273C4.10008 13.6462 3.60288 12.9021 3.26366 12.0831C2.92444 11.2642 2.74985 10.3864 2.74985 9.5C2.74985 7.70979 3.461 5.9929 4.72687 4.72703C5.99274 3.46116 7.70963 2.75 9.49984 2.75C11.2901 2.75 13.0069 3.46116 14.2728 4.72703C15.5387 5.9929 16.2498 7.70979 16.2498 9.5ZM15.0198 16.61C13.2114 18.014 10.9359 18.676 8.65654 18.4612C6.37719 18.2465 4.26536 17.1711 2.75097 15.4541C1.23658 13.7371 0.433472 11.5074 0.505148 9.21912C0.576825 6.9308 1.51789 4.75581 3.13678 3.13693C4.75566 1.51805 6.93065 0.576977 9.21897 0.505301C11.5073 0.433625 13.7369 1.23673 15.4539 2.75112C17.171 4.26552 18.2463 6.37735 18.4611 8.6567C18.6758 10.936 18.0138 13.2116 16.6098 15.02L20.7948 19.205C20.9054 19.308 20.994 19.4322 21.0555 19.5702C21.117 19.7082 21.1501 19.8572 21.1527 20.0082C21.1554 20.1593 21.1276 20.3093 21.071 20.4494C21.0144 20.5895 20.9302 20.7167 20.8234 20.8236C20.7166 20.9304 20.5893 21.0146 20.4492 21.0712C20.3092 21.1278 20.1591 21.1556 20.0081 21.1529C19.857 21.1502 19.708 21.1172 19.57 21.0557C19.432 20.9942 19.3078 20.9055 19.2048 20.795L15.0198 16.61Z"
        fill={color}
      />
    </svg>
  );
};

export default SearchIcon;
